/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { Button, Grid, TextField, Typography } from '@upperhand/playmaker';
import * as authActions from 'store/actions/auth';

const useLoginForm = () => {
  const [{ email, password, code }, setLoginData] = useState({
    email: '',
    password: '',
    code: '',
  });

  const updateLoginForm = (field, value) =>
    setLoginData(loginData => ({ ...loginData, [field]: value }));

  return {
    email,
    password,
    code,
    updateLoginForm,
  };
};

const LoginForm = props => {
  const { email, password, code, updateLoginForm } = useLoginForm();
  const { error, logIn } = props;

  // NOTE: This would not be necessary if we allowed key events on <TextField />.
  const handleDivKeyDown = useCallback(
    e => {
      if (e.key === 'Enter') {
        logIn(email, password, code);
      }
    },
    [logIn, email, password, code]
  );

  return (
    <Grid item container spacing={3} className="form__container">
      <Grid item xs={12}>
        <Typography variant="h6" fullWidth>
          Enter your Upper Hand login information below.
        </Typography>
      </Grid>

      {error && (
        <Grid item xs={12}>
          <Typography variant="body1" color="error">
            {error}
          </Typography>
        </Grid>
      )}

      <Grid item xs={12}>
        <div onKeyDown={handleDivKeyDown}>
          <TextField
            autoFocus
            onChange={e => updateLoginForm('email', e.target.value)}
            outline
            fullWidth
            placeholder="Email address"
            label="Email address"
            type="email"
            value={email}
          />
        </div>
      </Grid>
      <Grid item xs={12}>
        <div onKeyDown={handleDivKeyDown}>
          <TextField
            onChange={e => updateLoginForm('password', e.target.value)}
            outline
            fullWidth
            placeholder="Password"
            label="Password"
            type="password"
            value={password}
          />
        </div>
      </Grid>
      <Grid item xs={12}>
        <div onKeyDown={handleDivKeyDown}>
          <TextField
            onChange={e => updateLoginForm('code', e.target.value)}
            outline
            fullWidth
            placeholder="Ex: upperhand"
            label="Group code"
            value={code}
          />
          <Typography variant="subtitle1" color="secondary">
            Enter your group code if provided.
          </Typography>
        </div>
      </Grid>
      <Grid item xs={12}>
        <Button fullWidth onClick={() => logIn(email, password, code)}>
          Log in
        </Button>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({ auth: { error }, logIn }) => ({
  error,
  logIn,
});

const mapDispatchToProps = dispatch => ({
  logIn: (email, password, code) =>
    dispatch(authActions.logIn(email, password, code)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
